module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('md-layout', {
    attrs: {
      "md-align": "center",
      "md-vertical-align": "start"
    }
  }, [_c('md-card', {
    staticStyle: {
      "width": "80%"
    },
    attrs: {
      "md-with-hover": ""
    }
  }, [_c('md-card-header', [_c('div', {
    staticClass: "md-title"
  }, [_vm._v("Previous Experiments")]), _vm._v(" "), _c('div', {
    staticClass: "md-subhead"
  })]), _vm._v(" "), _c('md-card-content', [_c('md-table', [_c('md-table-header', [_c('md-table-row', [_c('md-table-head', [_vm._v("#")]), _vm._v(" "), _c('md-table-head', [_vm._v("Datetime")]), _vm._v(" "), _c('md-table-head', [_vm._v("Experiment type")]), _vm._v(" "), _c('md-table-head'), _vm._v(" "), _c('md-table-head')], 1)], 1), _vm._v(" "), _c('md-table-body', _vm._l((_vm.experiments), function(exp, index) {
    return _c('md-table-row', {
      key: index
    }, [_c('md-table-cell', [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('md-table-cell', [_vm._v(_vm._s(_vm._f("moment")(exp.started_at, "MMMM Do YYYY, HH:mm")))]), _vm._v(" "), _c('md-table-cell', [(exp.exp_type == 0) ? _c('span', [_vm._v("Like\\Dislike")]) : _vm._e(), _vm._v(" "), (exp.exp_type == 1) ? _c('span', [_vm._v("Human\\GAN")]) : _vm._e(), _vm._v(" "), (exp.exp_type == 2) ? _c('span', [_vm._v("EMOTIV")]) : _vm._e()]), _vm._v(" "), _c('md-table-cell', [_c('router-link', {
      staticClass: "md-raised md-primary",
      staticStyle: {
        "width": "60%"
      },
      attrs: {
        "tag": "a",
        "to": {
          name: 'experiment_result',
          params: {
            id: exp.id
          }
        }
      }
    }, [_vm._v("Details")])], 1), _vm._v(" "), _c('md-table-cell', [_c('md-button', {
      staticClass: "md-fab md-mini open-button",
      on: {
        "click": function($event) {
          return _vm.DeleteExperiment(exp.id)
        }
      }
    }, [_c('md-icon', [_vm._v("close")])], 1)], 1)], 1)
  }), 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e68006cc"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ExperimentPassed.vue
// module id = 344
// module chunks = 1